import Header from '../components/Header';
import Footer from '../components/Footer';
import { Localization } from '../../model/store/providers/Localization';
import './ErrorPage.scss';
import { useContext } from 'react';
import { resourcesBaseUri } from '../../config';

export default function ErrorPage() {
	const { translations } = useContext(Localization.State);
	const {
		errorPage: {
			title,
			subtitle
		}
	} = translations;

	return (
		<div className="outer-container">
			<Header />
			<div className="error-page">
				<img
					className="error-page__image"
					src={`${resourcesBaseUri}/404.svg`}
					alt=""
				/>
				<p className="error-page__title">{title}</p>
				<p className="error-page__subtitle">{subtitle}</p>
			</div>
			<Footer />
		</div>
	);
}

